import { Component, OnInit, HostListener } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { MyService } from '../../services/myservice';
import { right } from '@popperjs/core';
import { ExternalService } from '../../services/external.service';
import { ToastrService } from 'ngx-toastr';
import { NavigationEnd, Router } from '@angular/router';
import { ProductService } from '../../services/product.service';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { filter } from 'rxjs';

@Component({
  selector: 'app-tap-to-top',
  templateUrl: './tap-to-top.component.html',
  styleUrls: ['./tap-to-top.component.scss']
})
export class TapToTopComponent implements OnInit {

  public show: boolean = false;
  clickedQuestionIds = new Set<number>(); // This keeps track of which questions have been clicked


  DataChat: any = []
  public LogHide: boolean = true;
  hideheader: boolean = true;
  loginIdpage: number = 0
  constructor(private viewScroller: ViewportScroller, private myService: MyService, private fb: UntypedFormBuilder,
    private externalService: ExternalService, private toastrService: ToastrService, private router: Router, public productService: ProductService,) {

    // this.myService.InitialChat.subscribe(chatdata => {
    //   console.log(chatdata)
    //   this.details = chatdata
    // })


    const logPageId = localStorage.getItem('logPageId');
    // console.log(logPageId);
    this.loginIdpage = Number(logPageId);
    // console.log(this.loginIdpage);


    const chatdata = JSON.parse(localStorage.getItem('chatdetails') || '[]');
    // console.log(chatdata)
    this.details = chatdata

    this.myService.chathistory.subscribe(xadata => {
      // console.log(xadata)
      if (xadata == 1) {
        localStorage.removeItem('chatQA');
        this.chathisId = xadata
        this.details = []
        this.chatQA = []
      }
    })

    this.LogHide = false
    // this.route.queryParams.subscribe(params => {
    //   this.hideheader = params['hideheader'] === 'true'; 
    // });

    this.hideheader = true;
    this.router.navigate['/pages/login'];


    this.Login = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('[a-zA-Z][a-zA-Z ]+[a-zA-Z]$'), Validators.maxLength(40)]],
      // phoneno: ['', [Validators.required, Validators.pattern('[0-9]+'), Validators.maxLength(10)]],
      // phoneNo: ['', [Validators.required, Validators.pattern('[0-9]+'), Validators.maxLength(10)]],
      phoneNo: ['', [Validators.required, Validators.pattern('[6-9][0-9]{9}'), Validators.maxLength(10)]]
    })

    // this.fbform = this.fb.group({ 
    // })  

    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.logback();
      this.loginphone()
    });


    this.myService.ChatId.subscribe(data => {
      // console.log(data)
      this.IdChat = data
      // console.log(this.IdChat)
    })
    // console.log('---------------------------------------')

    const name = localStorage.getItem('name') || "User";

    this.CusName = name

    this.DataChat = JSON.parse(localStorage.getItem("Chat"));
    // console.log(this.DataChat)
  }

  IdChat: number = 0
  custIdHide: number = 0
  currentTime: string = '';
  chathisId: number = 0
  ngOnInit(): void {
    const stored = localStorage.getItem('clickedQuestions');
    if (stored) {
      this.clickedQuestionIds = new Set(JSON.parse(stored));
    }

    const logPageId = localStorage.getItem('logPageId');;
    // console.log(logPageId);
    this.loginIdpage = Number(logPageId);
    // console.log(this.loginIdpage);


    this.myService.chathistory.subscribe(xadata => {
      // console.log(xadata)
      if (xadata == 1) {
        localStorage.removeItem('chatQA');
        this.chathisId = xadata
        this.details = []
        this.chatQA = []
        this.custIdHide = 0
      }
    })

    // this.myService.InitialChat.subscribe(chatdata => {
    //   console.log(chatdata)
    //   this.details = chatdata
    // })

    this.currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    const storedQues = JSON.parse(localStorage.getItem('chatQUes') || '[]');
    this.chatQues = storedQues;

    this.custIdHide = parseInt(localStorage.getItem('customerid') || '0', 10) || 0;
    // this.send()
    this.myService.ChatId.subscribe(data => {
      // console.log(data)
      this.IdChat = data
      // console.log(this.IdChat)
    })


    this.getchat(); // to load questions
    this.loadChatFromStorage()

    // const chatdata = JSON.parse(localStorage.getItem('chatdetails') || '[]');
    // console.log(chatdata)
    // this.details = chatdata

  }

  // @HostListener Decorator
  @HostListener("window:scroll", [])
  onWindowScroll() {
    let number = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (number > 600) {
      this.show = true;
    } else {
      this.show = false;
    }
  }

  tapToTop() {
    this.viewScroller.scrollToPosition([0, 0]);
  }


  chathide: boolean = false

  openchat(id: number) {
    this.chathide = true;
    this.getchat();

    // this.getanswer(4);
  }

  closechat() {
    this.chathide = false
    this.IdChat = 0
  }

  chatstyle = `
  <style>

    .msg {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}
.msg:last-of-type {
  margin: 0;
}
.msg-img {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  background: #ddd;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
}
.msg-bubble {
  max-width: 450px;
  padding: 15px;
  border-radius: 15px;
  background: #ececec;
}
.msg-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.msg-info-name {
  margin-right: 10px;
  font-weight: bold;
}
.msg-info-time {
  font-size: 0.85em;
}

.left-msg .msg-bubble {
  border-bottom-left-radius: 0;
}

.right-msg {
  flex-direction: row-reverse;
}
.right-msg .msg-bubble {
  background: #b68c8c1f;
  color: #000000;
  border-bottom-right-radius: 0;
}
.right-msg .msg-img {
  margin: 0 0 0 10px;
}

.msger-inputarea {
  display: flex;
  padding: 10px;
//   border-top: var(--border);
  background: #eee;
}
.msger-inputarea * {
  padding: 10px;
  border: none;
  border-radius: 3px;
  font-size: 1em;
}
.msger-input {
  flex: 1;
  background: #ddd;
}
.msger-send-btn {
  margin-left: 10px;
  background: rgb(0, 196, 65);
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.23s;
}
.msger-send-btn:hover {
  background: rgb(0, 180, 50);
}

.msger-chat {
  background-color: #fcfcfe;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='260' height='260' viewBox='0 0 260 260'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23dddddd' fill-opacity='0.4'%3E%3Cpath d='M24.37 16c.2.65.39 1.32.54 2H21.17l1.17 2.34.45.9-.24.11V28a5 5 0 0 1-2.23 8.94l-.02.06a8 8 0 0 1-7.75 6h-20a8 8 0 0 1-7.74-6l-.02-.06A5 5 0 0 1-17.45 28v-6.76l-.79-1.58-.44-.9.9-.44.63-.32H-20a23.01 23.01 0 0 1 44.37-2zm-36.82 2a1 1 0 0 0-.44.1l-3.1 1.56.89 1.79 1.31-.66a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .86.02l2.88-1.27a3 3 0 0 1 2.43 0l2.88 1.27a1 1 0 0 0 .85-.02l3.1-1.55-.89-1.79-1.42.71a3 3 0 0 1-2.56.06l-2.77-1.23a1 1 0 0 0-.4-.09h-.01a1 1 0 0 0-.4.09l-2.78 1.23a3 3 0 0 1-2.56-.06l-2.3-1.15a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1L.9 19.22a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1l-2.21 1.11a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01zm0-2h-4.9a21.01 21.01 0 0 1 39.61 0h-2.09l-.06-.13-.26.13h-32.31zm30.35 7.68l1.36-.68h1.3v2h-36v-1.15l.34-.17 1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0l1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0L2.26 23h2.59l1.36.68a3 3 0 0 0 2.56.06l1.67-.74h3.23l1.67.74a3 3 0 0 0 2.56-.06zM-13.82 27l16.37 4.91L18.93 27h-32.75zm-.63 2h.34l16.66 5 16.67-5h.33a3 3 0 1 1 0 6h-34a3 3 0 1 1 0-6zm1.35 8a6 6 0 0 0 5.65 4h20a6 6 0 0 0 5.66-4H-13.1z'/%3E%3Cpath id='path6_fill-copy' d='M284.37 16c.2.65.39 1.32.54 2H281.17l1.17 2.34.45.9-.24.11V28a5 5 0 0 1-2.23 8.94l-.02.06a8 8 0 0 1-7.75 6h-20a8 8 0 0 1-7.74-6l-.02-.06a5 5 0 0 1-2.24-8.94v-6.76l-.79-1.58-.44-.9.9-.44.63-.32H240a23.01 23.01 0 0 1 44.37-2zm-36.82 2a1 1 0 0 0-.44.1l-3.1 1.56.89 1.79 1.31-.66a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .9 0l2.21-1.1a3 3 0 0 1 2.69 0l2.2 1.1a1 1 0 0 0 .86.02l2.88-1.27a3 3 0 0 1 2.43 0l2.88 1.27a1 1 0 0 0 .85-.02l3.1-1.55-.89-1.79-1.42.71a3 3 0 0 1-2.56.06l-2.77-1.23a1 1 0 0 0-.4-.09h-.01a1 1 0 0 0-.4.09l-2.78 1.23a3 3 0 0 1-2.56-.06l-2.3-1.15a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1l-2.21 1.11a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01a1 1 0 0 0-.44.1l-2.21 1.11a3 3 0 0 1-2.69 0l-2.2-1.1a1 1 0 0 0-.45-.11h-.01zm0-2h-4.9a21.01 21.01 0 0 1 39.61 0h-2.09l-.06-.13-.26.13h-32.31zm30.35 7.68l1.36-.68h1.3v2h-36v-1.15l.34-.17 1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0l1.36-.68h2.59l1.36.68a3 3 0 0 0 2.69 0l1.36-.68h2.59l1.36.68a3 3 0 0 0 2.56.06l1.67-.74h3.23l1.67.74a3 3 0 0 0 2.56-.06zM246.18 27l16.37 4.91L278.93 27h-32.75zm-.63 2h.34l16.66 5 16.67-5h.33a3 3 0 1 1 0 6h-34a3 3 0 1 1 0-6zm1.35 8a6 6 0 0 0 5.65 4h20a6 6 0 0 0 5.66-4H246.9z'/%3E%3Cpath d='M159.5 21.02A9 9 0 0 0 151 15h-42a9 9 0 0 0-8.5 6.02 6 6 0 0 0 .02 11.96A8.99 8.99 0 0 0 109 45h42a9 9 0 0 0 8.48-12.02 6 6 0 0 0 .02-11.96zM151 17h-42a7 7 0 0 0-6.33 4h54.66a7 7 0 0 0-6.33-4zm-9.34 26a8.98 8.98 0 0 0 3.34-7h-2a7 7 0 0 1-7 7h-4.34a8.98 8.98 0 0 0 3.34-7h-2a7 7 0 0 1-7 7h-4.34a8.98 8.98 0 0 0 3.34-7h-2a7 7 0 0 1-7 7h-7a7 7 0 1 1 0-14h42a7 7 0 1 1 0 14h-9.34zM109 27a9 9 0 0 0-7.48 4H101a4 4 0 1 1 0-8h58a4 4 0 0 1 0 8h-.52a9 9 0 0 0-7.48-4h-42z'/%3E%3Cpath d='M39 115a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm6-8a6 6 0 1 1-12 0 6 6 0 0 1 12 0zm-3-29v-2h8v-6H40a4 4 0 0 0-4 4v10H22l-1.33 4-.67 2h2.19L26 130h26l3.81-40H58l-.67-2L56 84H42v-6zm-4-4v10h2V74h8v-2h-8a2 2 0 0 0-2 2zm2 12h14.56l.67 2H22.77l.67-2H40zm13.8 4H24.2l3.62 38h22.36l3.62-38z'/%3E%3Cpath d='M129 92h-6v4h-6v4h-6v14h-3l.24 2 3.76 32h36l3.76-32 .24-2h-3v-14h-6v-4h-6v-4h-8zm18 22v-12h-4v4h3v8h1zm-3 0v-6h-4v6h4zm-6 6v-16h-4v19.17c1.6-.7 2.97-1.8 4-3.17zm-6 3.8V100h-4v23.8a10.04 10.04 0 0 0 4 0zm-6-.63V104h-4v16a10.04 10.04 0 0 0 4 3.17zm-6-9.17v-6h-4v6h4zm-6 0v-8h3v-4h-4v12h1zm27-12v-4h-4v4h3v4h1v-4zm-6 0v-8h-4v4h3v4h1zm-6-4v-4h-4v8h1v-4h3zm-6 4v-4h-4v8h1v-4h3zm7 24a12 12 0 0 0 11.83-10h7.92l-3.53 30h-32.44l-3.53-30h7.92A12 12 0 0 0 130 126z'/%3E%3Cpath d='M212 86v2h-4v-2h4zm4 0h-2v2h2v-2zm-20 0v.1a5 5 0 0 0-.56 9.65l.06.25 1.12 4.48a2 2 0 0 0 1.94 1.52h.01l7.02 24.55a2 2 0 0 0 1.92 1.45h4.98a2 2 0 0 0 1.92-1.45l7.02-24.55a2 2 0 0 0 1.95-1.52L224.5 96l.06-.25a5 5 0 0 0-.56-9.65V86a14 14 0 0 0-28 0zm4 0h6v2h-9a3 3 0 1 0 0 6H223a3 3 0 1 0 0-6H220v-2h2a12 12 0 1 0-24 0h2zm-1.44 14l-1-4h24.88l-1 4h-22.88zm8.95 26l-6.86-24h18.7l-6.86 24h-4.98zM150 242a22 22 0 1 0 0-44 22 22 0 0 0 0 44zm24-22a24 24 0 1 1-48 0 24 24 0 0 1 48 0zm-28.38 17.73l2.04-.87a6 6 0 0 1 4.68 0l2.04.87a2 2 0 0 0 2.5-.82l1.14-1.9a6 6 0 0 1 3.79-2.75l2.15-.5a2 2 0 0 0 1.54-2.12l-.19-2.2a6 6 0 0 1 1.45-4.46l1.45-1.67a2 2 0 0 0 0-2.62l-1.45-1.67a6 6 0 0 1-1.45-4.46l.2-2.2a2 2 0 0 0-1.55-2.13l-2.15-.5a6 6 0 0 1-3.8-2.75l-1.13-1.9a2 2 0 0 0-2.5-.8l-2.04.86a6 6 0 0 1-4.68 0l-2.04-.87a2 2 0 0 0-2.5.82l-1.14 1.9a6 6 0 0 1-3.79 2.75l-2.15.5a2 2 0 0 0-1.54 2.12l.19 2.2a6 6 0 0 1-1.45 4.46l-1.45 1.67a2 2 0 0 0 0 2.62l1.45 1.67a6 6 0 0 1 1.45 4.46l-.2 2.2a2 2 0 0 0 1.55 2.13l2.15.5a6 6 0 0 1 3.8 2.75l1.13 1.9a2 2 0 0 0 2.5.8zm2.82.97a4 4 0 0 1 3.12 0l2.04.87a4 4 0 0 0 4.99-1.62l1.14-1.9a4 4 0 0 1 2.53-1.84l2.15-.5a4 4 0 0 0 3.09-4.24l-.2-2.2a4 4 0 0 1 .97-2.98l1.45-1.67a4 4 0 0 0 0-5.24l-1.45-1.67a4 4 0 0 1-.97-2.97l.2-2.2a4 4 0 0 0-3.09-4.25l-2.15-.5a4 4 0 0 1-2.53-1.84l-1.14-1.9a4 4 0 0 0-5-1.62l-2.03.87a4 4 0 0 1-3.12 0l-2.04-.87a4 4 0 0 0-4.99 1.62l-1.14 1.9a4 4 0 0 1-2.53 1.84l-2.15.5a4 4 0 0 0-3.09 4.24l.2 2.2a4 4 0 0 1-.97 2.98l-1.45 1.67a4 4 0 0 0 0 5.24l1.45 1.67a4 4 0 0 1 .97 2.97l-.2 2.2a4 4 0 0 0 3.09 4.25l2.15.5a4 4 0 0 1 2.53 1.84l1.14 1.9a4 4 0 0 0 5 1.62l2.03-.87zM152 207a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm6 2a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-11 1a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-6 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm3-5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-8 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm3 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm0 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm4 7a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm5-2a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm5 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm4-6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm6-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-4-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm4-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-5-4a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm-24 6a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm16 5a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm7-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0zm86-29a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm19 9a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-14 5a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-25 1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm5 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm9 0a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm15 1a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm12-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-11-14a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-19 0a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm6 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-25 15c0-.47.01-.94.03-1.4a5 5 0 0 1-1.7-8 3.99 3.99 0 0 1 1.88-5.18 5 5 0 0 1 3.4-6.22 3 3 0 0 1 1.46-1.05 5 5 0 0 1 7.76-3.27A30.86 30.86 0 0 1 246 184c6.79 0 13.06 2.18 18.17 5.88a5 5 0 0 1 7.76 3.27 3 3 0 0 1 1.47 1.05 5 5 0 0 1 3.4 6.22 4 4 0 0 1 1.87 5.18 4.98 4.98 0 0 1-1.7 8c.02.46.03.93.03 1.4v1h-62v-1zm.83-7.17a30.9 30.9 0 0 0-.62 3.57 3 3 0 0 1-.61-4.2c.37.28.78.49 1.23.63zm1.49-4.61c-.36.87-.68 1.76-.96 2.68a2 2 0 0 1-.21-3.71c.33.4.73.75 1.17 1.03zm2.32-4.54c-.54.86-1.03 1.76-1.49 2.68a3 3 0 0 1-.07-4.67 3 3 0 0 0 1.56 1.99zm1.14-1.7c.35-.5.72-.98 1.1-1.46a1 1 0 1 0-1.1 1.45zm5.34-5.77c-1.03.86-2 1.79-2.9 2.77a3 3 0 0 0-1.11-.77 3 3 0 0 1 4-2zm42.66 2.77c-.9-.98-1.87-1.9-2.9-2.77a3 3 0 0 1 4.01 2 3 3 0 0 0-1.1.77zm1.34 1.54c.38.48.75.96 1.1 1.45a1 1 0 1 0-1.1-1.45zm3.73 5.84c-.46-.92-.95-1.82-1.5-2.68a3 3 0 0 0 1.57-1.99 3 3 0 0 1-.07 4.67zm1.8 4.53c-.29-.9-.6-1.8-.97-2.67.44-.28.84-.63 1.17-1.03a2 2 0 0 1-.2 3.7zm1.14 5.51c-.14-1.21-.35-2.4-.62-3.57.45-.14.86-.35 1.23-.63a2.99 2.99 0 0 1-.6 4.2zM275 214a29 29 0 0 0-57.97 0h57.96zM72.33 198.12c-.21-.32-.34-.7-.34-1.12v-12h-2v12a4.01 4.01 0 0 0 7.09 2.54c.57-.69.91-1.57.91-2.54v-12h-2v12a1.99 1.99 0 0 1-2 2 2 2 0 0 1-1.66-.88zM75 176c.38 0 .74-.04 1.1-.12a4 4 0 0 0 6.19 2.4A13.94 13.94 0 0 1 84 185v24a6 6 0 0 1-6 6h-3v9a5 5 0 1 1-10 0v-9h-3a6 6 0 0 1-6-6v-24a14 14 0 0 1 14-14 5 5 0 0 0 5 5zm-17 15v12a1.99 1.99 0 0 0 1.22 1.84 2 2 0 0 0 2.44-.72c.21-.32.34-.7.34-1.12v-12h2v12a3.98 3.98 0 0 1-5.35 3.77 3.98 3.98 0 0 1-.65-.3V209a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-24c.01-1.53-.23-2.88-.72-4.17-.43.1-.87.16-1.28.17a6 6 0 0 1-5.2-3 7 7 0 0 1-6.47-4.88A12 12 0 0 0 58 185v6zm9 24v9a3 3 0 1 0 6 0v-9h-6z'/%3E%3Cpath d='M-17 191a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm19 9a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2H3a1 1 0 0 1-1-1zm-14 5a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm-25 1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm5 4a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm9 0a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm15 1a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm12-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2H4zm-11-14a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-19 0a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2zm6 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm-25 15c0-.47.01-.94.03-1.4a5 5 0 0 1-1.7-8 3.99 3.99 0 0 1 1.88-5.18 5 5 0 0 1 3.4-6.22 3 3 0 0 1 1.46-1.05 5 5 0 0 1 7.76-3.27A30.86 30.86 0 0 1-14 184c6.79 0 13.06 2.18 18.17 5.88a5 5 0 0 1 7.76 3.27 3 3 0 0 1 1.47 1.05 5 5 0 0 1 3.4 6.22 4 4 0 0 1 1.87 5.18 4.98 4.98 0 0 1-1.7 8c.02.46.03.93.03 1.4v1h-62v-1zm.83-7.17a30.9 30.9 0 0 0-.62 3.57 3 3 0 0 1-.61-4.2c.37.28.78.49 1.23.63zm1.49-4.61c-.36.87-.68 1.76-.96 2.68a2 2 0 0 1-.21-3.71c.33.4.73.75 1.17 1.03zm2.32-4.54c-.54.86-1.03 1.76-1.49 2.68a3 3 0 0 1-.07-4.67 3 3 0 0 0 1.56 1.99zm1.14-1.7c.35-.5.72-.98 1.1-1.46a1 1 0 1 0-1.1 1.45zm5.34-5.77c-1.03.86-2 1.79-2.9 2.77a3 3 0 0 0-1.11-.77 3 3 0 0 1 4-2zm42.66 2.77c-.9-.98-1.87-1.9-2.9-2.77a3 3 0 0 1 4.01 2 3 3 0 0 0-1.1.77zm1.34 1.54c.38.48.75.96 1.1 1.45a1 1 0 1 0-1.1-1.45zm3.73 5.84c-.46-.92-.95-1.82-1.5-2.68a3 3 0 0 0 1.57-1.99 3 3 0 0 1-.07 4.67zm1.8 4.53c-.29-.9-.6-1.8-.97-2.67.44-.28.84-.63 1.17-1.03a2 2 0 0 1-.2 3.7zm1.14 5.51c-.14-1.21-.35-2.4-.62-3.57.45-.14.86-.35 1.23-.63a2.99 2.99 0 0 1-.6 4.2zM15 214a29 29 0 0 0-57.97 0h57.96z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
  </style>`;


  send1() {
    // console.log('sfthfds');
    const dataarray = []
    const msgerForm = get(".msger-inputarea");
    const msgerInput = get(".msger-input");
    const msgerChat = get(".msger-chat");

    let ChatMsg = {
      id: 0,
      sender: '',
      receiver: '',
      sendTime: '',
      receiveTime: ''
    }

    const BOT_MSGS = [
      {
        "keywords": ["open", "working hours", "business hours"],
        "response": "We are open daily from 10:00 AM to 9:00 PM, including weekends!"
      },
      {
        "keywords": ["menu", "catalog", "list of cakes"],
        "response": "You can view our cake menu here: https://yourwebsite.com/menu 📋"
      },
      {
        "keywords": ["eggless", "egg free"],
        "response": "Yes, we have 100% eggless cakes available in all flavors. 🎂🟢"
      },
      {
        "keywords": ["payment", "pay", "online", "card", "upi"],
        "response": "We accept UPI, card payments, net banking, and cash on delivery."
      },
      {
        "keywords": ["delivery charge", "fee"],
        "response": "Delivery charges depend on your location, starting from ₹49. Free delivery above ₹999!"
      },
      {
        "keywords": ["track", "status", "where is"],
        "response": "To track your order, please share your order ID. We'll check it for you."
      },
      {
        "keywords": ["phone", "contact", "number"],
        "response": "You can reach us at 📞 +91-98765 43210 or via WhatsApp."
      },
      {
        "keywords": ["whatsapp"],
        "response": "Yes! You can place orders and get support via WhatsApp at +91-98765 43210."
      },
      {
        "keywords": ["bulk", "corporate", "party"],
        "response": "We offer bulk and corporate orders for events and parties. Please contact us for discounts and options."
      },
      {
        "keywords": ["offers", "discount", "deal"],
        "response": "Check out our latest offers here: https://yourwebsite.com/offers 🎉"
      },
      {
        "keywords": ["store", "shop", "outlet"],
        "response": "Our main outlet is located at Karapakkam, Chennai. We also offer doorstep delivery."
      },
      {
        "keywords": ["thanks", "thank you"],
        "response": "You're welcome! 😊 Let us know if you need anything else."
      }
    ]


    const BOT_IMG = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-AAD2jIQT0p1MirMajjcczk0yaNbZTFnTwA&s";
    const PERSON_IMG = "https://static.wikia.nocookie.net/fourworldseries/images/c/c8/Hinata_Hyuga.png/revision/latest?cb=20170521160052";
    const BOT_NAME = "Customer Care";
    const cusid = localStorage.getItem('name');
    const PERSON_NAME = cusid || "User";

    msgerForm.addEventListener("submit", event => {
      event.preventDefault();

      const msgText = msgerInput.value;
      if (!msgText) return;

      appendMessage(PERSON_NAME, PERSON_IMG, "right", msgText);
      msgerInput.value = "";

      botResponse();
    });

    let mybotmsg = ""
    let textmsg = ""
    // console.log(mybotmsg)
    function appendMessage(name, img, side, text) {
      textmsg = text
      const str = text.toLowerCase()

      let regex = /time|delivery|timing/g;
      const exists = [...str.matchAll(regex)].length > 0;
      if (exists) {
        mybotmsg = "Our FB Cakes Delivery Time 10:00 AM to 09:00 PM"
      }

      regex = /hi|hello/g;
      const exists1 = [...str.matchAll(regex)].length > 0;
      if (exists1) {
        mybotmsg = "Hi,How can i help You?"
      }

      if (side == right) {
        ChatMsg.sender = text

        dataarray.push(ChatMsg)
        var msgHTML = `      
  <div class="msg right-msg" style="flex-direction: row-reverse;  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;">    

    <div class="msg-bubble" style=" background: rgb(220 147 147 / 38%); color: #000000;border-bottom-right-radius: 0;max-width: 300px;
    padding: 15px; border-radius: 15px;">

      <div class="msg-info" style="  display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">

        <div class="msg-info-name" style="  margin-right: 10px; font-weight: bold;">${name}</div>

        <div class="msg-info-time" style="font-size: 0.85em;">${formatDate(new Date())}</div>
      </div>
      <div class="msg-text" style="word-wrap: break-word">${text}</div>
    </div>
  </div>
`;
      } else {
        ChatMsg.receiver = text

        dataarray.push(ChatMsg)
        var msgHTML = `      
  <div class="msg left-msg" style="  border-bottom-left-radius: 0;  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;">
 
    <div class="msg-bubble"  style=" border-bottom-left-radius: 0;  max-width: 300px;  padding: 15px;  border-radius: 15px;  background: #d7d4d4a3;">

      <div class="msg-info"   style="  display: flex;  justify-content: space-between;  align-items: center;  margin-bottom: 10px;">

        <div class="msg-info-name"  style="margin-right: 10px;  font-weight: bold;">${name}</div>

        <div class="msg-info-time"  style="font-size: 0.85em;">${formatDate(new Date())}</div>
      </div>
      <div class="msg-text" style="word-wrap: break-word">${text}</div>
    </div>
  </div>
`;
      }

      // console.log(ChatMsg);
      // console.log(dataarray);

      msgerChat.insertAdjacentHTML("beforeend", msgHTML);
      msgerChat.scrollTop += 500;
    }

    function botResponse() {
      const r = random(0, BOT_MSGS.length - 1);
      // const msgText = BOT_MSGS[r];
      const msgText = mybotmsg
      const delay = msgText.split(" ").length * 100;

      setTimeout(() => {
        appendMessage(BOT_NAME, BOT_IMG, "left", msgText);
      }, delay);
    }

    function get(selector, root = document) {
      return root.querySelector(selector);
    }

    function formatDate(date) {
      const h = "0" + date.getHours();
      const m = "0" + date.getMinutes();

      return `${h.slice(-2)}:${m.slice(-2)}`;
    }

    function random(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    }

  }

  CusName = ''
  send() {
    const msgerInput = document.querySelector(".msger-input") as HTMLInputElement;
    const msgerChat = document.querySelector(".msger-chat");

    const BOT_MSGS = [
      "Ohh... I can't understand what you are trying to say. Sorry!",
    ];

    const BOT_IMG = "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR-AAD2jIQT0p1MirMajjcczk0yaNbZTFnTwA&s";
    const PERSON_IMG = "https://static.wikia.nocookie.net/fourworldseries/images/c/c8/Hinata_Hyuga.png/revision/latest?cb=20170521160052";
    const BOT_NAME = "Customer Care";
    const PERSON_NAME = localStorage.getItem('name') || "User";

    const msgText = msgerInput.value;
    if (!msgText.trim()) return;

    appendMessage(PERSON_NAME, PERSON_IMG, "right", msgText);
    msgerInput.value = "";
    botResponse(msgText);

    function appendMessage(name, img, side, text) {
      const msgHTML = `
      <div class="msg ${side}-msg" style="flex-direction: ${side === "right" ? "row-reverse" : "row"}; display: flex; align-items: flex-end; margin-bottom: 10px;margin-top:10px">
        <div class="msg-bubble" style="background: ${side === "right" ? "rgb(220 147 147 / 38%)" : "#d7d4d4a3"}; color: #000000; border-bottom-${side === "right" ? "right" : "left"}-radius: 0; max-width: 300px; padding: 15px; border-radius: 15px;margin-top: 10px;">
          <div class="msg-info" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
            <div class="msg-info-name" style="margin-right: 10px; font-weight: bold;">${name}</div>
            <div class="msg-info-time" style="font-size: 0.85em;">${formatDate(new Date())}</div>
          </div>
          <div class="msg-text" style="word-wrap: break-word">${text}</div>
        </div>
      </div>
    `;
      msgerChat.insertAdjacentHTML("beforeend", msgHTML);
      msgerChat.scrollTop += 500;
    }

    function botResponse(userText) {
      let botReply = BOT_MSGS[random(0, BOT_MSGS.length - 1)];

      const lowerText = userText.toLowerCase();
      if (/open|working hours|business hours/.test(lowerText)) {
        botReply = "We are open daily from 10:00 AM to 9:00 PM, including weekends!";
      } else if (/menu|catalog|list of cakes/.test(lowerText)) {
        botReply = "You can view our cake menu here: https://yourwebsite.com/menu 📋";
      } else if (/eggless|egg free/.test(lowerText)) {
        botReply = "Yes, we have 100% eggless cakes available in all flavors. 🎂🟢";
      } else if (/payment|pay|online|card|upi/.test(lowerText)) {
        botReply = "We accept UPI, card payments, net banking, and cash on delivery.";
      } else if (/delivery charge|fee/.test(lowerText)) {
        botReply = "Delivery charges depend on your location, starting from ₹49. Free delivery above ₹999!";
      } else if (/track|status|where is/.test(lowerText)) {
        botReply = "To track your order, please share your order ID. We'll check it for you.";
      } else if (/phone|contact|number/.test(lowerText)) {
        botReply = "You can reach us at 📞 +91-98765 43210 or via WhatsApp.";
      } else if (/whatsapp/.test(lowerText)) {
        botReply = "Yes! You can place orders and get support via WhatsApp at +91-98765 43210.";
      } else if (/bulk|corporate|party/.test(lowerText)) {
        botReply = "We offer bulk and corporate orders for events and parties. Please contact us for discounts and options.";
      } else if (/offers|discount|deal/.test(lowerText)) {
        botReply = "Check out our latest offers here: https://yourwebsite.com/offers 🎉";
      } else if (/store|shop|outlet/.test(lowerText)) {
        botReply = "Our main outlet is located at Karapakkam, Chennai. We also offer doorstep delivery.";
      } else if (/thanks|thank you/.test(lowerText)) {
        botReply = "You're welcome! 😊 Let us know if you need anything else.";
      }

      setTimeout(() => {
        appendMessage(BOT_NAME, BOT_IMG, "left", botReply);

        const chatArray = JSON.parse(localStorage.getItem("Chat") || "[]");
        chatArray.push({
          id: chatArray.length + 1,
          sender: msgText,
          receiver: botReply,
          sendTime: formatDate(new Date()),
          receiveTime: formatDate(new Date())
        });
        localStorage.setItem("Chat", JSON.stringify(chatArray));
      }, botReply.split(" ").length * 100);
    }

    function formatDate(date: Date) {
      const h = "0" + date.getHours();
      const m = "0" + date.getMinutes();
      return `${h.slice(-2)}:${m.slice(-2)}`;
    }

    function random(min: number, max: number) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }
  }


  chatData: any = []



  // login

  otpmsg = "";
  // OLD CUSTOMER LOGIN
  custorId: any
  mobile: number

  enterotp: string = '';
  enterotp1: string = '';
  enterotp2: string = '';
  enterotp3: string = '';


  login: any = {
    name: '',
    phoneno: '',
    email: '',
    cid: 12
  };
  submitted: boolean = false;
  test: any
  custid: number;
  GetOldCustomerLogin() {
    this.mobile = this.login.phoneno
    // console.log(this.custid, this.mobile);
    this.enterotp = null,
      this.enterotp1 = null,
      this.enterotp2 = null,
      this.enterotp3 = null
    this.externalService.GetOldCustomer(this.custid, this.mobile, this.test);
    this.externalService._getoldCustomer.subscribe(response => {
      const oldCus = response
      // console.log(oldCus);
      // this.toastrService.success('OTP', ' Otp Verified Saved Successfully')
      var response = response as ExternalService[];
      if (response && response['status'] == 200) {
        //  this.toastrService.success(`${this.mobile} Successfully.`, 'Verification code sent to',)
        this.toastrService.success(`${this.mobile} Successfully.`, response['service'],)
        this.submitted = false
      } else {
        this.toastrService.error(`${this.mobile} UnSuccessfully.!..`, 'Verification code sent to',)
      }
    })
  }
  customerId: number
  CusOTP: any
  GetNewcusOtp() {
    this.CusOTP = `${this.enterotp}${this.enterotp1}${this.enterotp2}${this.enterotp3}`;
    this.custid = this.customerId;

    this.externalService.GetCustomerOtp(this.custid, this.CusOTP, 12, this.test);

    this.externalService._getCustomerOtp.subscribe(response => {
      if (response["status"] === 200) {
        this.custIdHide = this.custid
        this.chathisId = 0
        this.getchat()
        this.otpshow = false
        this.toastrService.success('OTP', 'OTP Verified Successfully');
        // Store user data in local storage
        localStorage.setItem('customerid', this.custid?.toString());
        localStorage.setItem('denglu', '1');
        localStorage.setItem('secid', response["secid"]);
        localStorage.setItem('name', response["name"]);

        this.myService.name.next(response["name"]);
        localStorage.setItem('myApp_CartCount', response["cartcount"]);

        this.myService.cartsource.next(response["cartcount"]);

        const storedValue = localStorage.getItem('mypg');
        const productId = localStorage.getItem('productId');
        const prdname = localStorage.getItem('prdname');
        const chatdata = JSON.parse(localStorage.getItem('chatdetails') || '[]');
        // console.log(chatdata)
        this.details = chatdata
        // console.log(storedValue, productId, prdname);
        if (storedValue === "2") {
          let cartdata = JSON.parse(localStorage.getItem('Cart') || '[]');
          const customerId = parseInt(localStorage.getItem('customerid') || '0', 10);
          // console.log(cartdata)
          if (cartdata.length > 0) {
            // Assign customer ID to each cart item
            cartdata = cartdata.map(item => ({ ...item, customerid: customerId || null }));

            this.productService.SaveCArt(cartdata[0]).subscribe(responsecart => {
              if (responsecart["status"] == 200) {
                // this.router.navigateByUrl('/shop/cart');

                this.toastrService.success('Cart', 'Cart Added Successfully');

                // Clear Cart data
                localStorage.removeItem('Cart');

                // Update cart count in local storage
                localStorage.setItem("myApp_CartCount", responsecart.cartcount.toString());
                this.myService.cartsource.next(responsecart.cartcount);
              } else {
                this.toastrService.error('Cart', 'Failed to save cart');
              }
            }, error => {
              // console.error("API Error:", error);
              this.toastrService.error('Cart', 'An error occurred while saving the cart');
            });
          } else {
            this.router.navigateByUrl(`/shop/product/details/${productId}/${prdname}`);
          }
        } else {
          switch (storedValue) {
            case '0':
              this.router.navigateByUrl('home/cakes');
              break;
            case '1':
              this.router.navigateByUrl('/shop/cakes/collection?category=118');
              break;
            case '3':
              this.router.navigateByUrl('/shop/cart');
              break;
            default:
              this.router.navigateByUrl('home/cakes');
              break;
          }
        }
      } else {
        this.toastrService.error('OTP', 'OTP Verification Unsuccessful');
      }
    });
  }

  otpMove(o1: any, o2: any, o3: any, o4: any, o5: any) {
    const length = o3.value.length;
    const maxlength = o3.getAttribute('maxlength');
    if (length == maxlength) {
      if (o5 == '') {
        return;
      }
      if (o4 != '') {
        o4.focus();
      }
    }
    if (o1.key == 'Backspace') {
      if (o1 != '') {
        o2?.focus();
      }
    }
  }

  public Login: UntypedFormGroup;
  // public fbform: UntypedFormGroup;
  public loginshow: boolean = false;
  public otpshow: boolean = false;
  public logphshow: boolean = true;
  phoneNo: any

  loginphone() {
    this.otpshow = false
    // this.loginshow = true
    this.logphshow = true
    this.submitted = false
    // this.login.reset();
    this.login = {
      name: '',
      phoneno: '',
      email: '',
    };
    this.phoneNo = null
    this.enterotp = null;
    this.enterotp1 = null;
    this.enterotp2 = null;
    this.enterotp3 = null;
    this.Login.reset();
  }

  customerData: any
  SaveNewCustomer() {
    // console.log(this.login)
    this.login.cid = 12
    this.externalService.GetNewCust(this.login)
    // console.log('hii', this.login);

    this.externalService._getcustomerAdd.subscribe(response => {
      this.customerData = response
      // console.log('CustomerData', this.customerData);

      this.customerId = this.customerData.custid,
        // console.log('Cid', this.customerId);

        // localStorage.setItem('custid', this.customerId?.toString());

        this.custid = this.customerId,
        // console.log('custid', this.custid);

        this.loginshow = false
      this.otpshow = true
      this.submitted = false

      // var response = response
      // if (response && response['status'] == 200) {
      //   this.toastrService.success('Customer', ' Customer Addd Successfully')
      //   this.loginshow = false
      //   this.otpshow = true
      //   this.submitted = false
      // } else {
      //   this.toastrService.error('Customer', ' Customer Addd UnSuccessfully !..')
      // }
    })

  }

  logback() {
    this.loginshow = false
    this.logphshow = true
    this.phoneNo = null
    this.submitted = false
    this.login = {
      name: '',
      phoneno: '',
      email: '',
    };
    this.Login.reset();
  }

  emailInputTouched = false;
  onInput(event: any) {
    this.emailInputTouched = true;
  }

  isDisabled: boolean = true;

  validateAlphabeticInput(event: KeyboardEvent) {
    const keyCode = event.keyCode;
    const allowedKeyCodes = [8, 9, 32];
    if (!((keyCode >= 65 && keyCode <= 90) || (keyCode >= 97 && keyCode <= 122) || allowedKeyCodes.includes(keyCode))) {
      event.preventDefault();
    }
  }

  oldCus: any
  getloginData() {
    this.submitted = true;

    if (this.Login.controls.phoneNo.invalid) {
      return true;
    }

    this.isDisabled = true
    const phoneNumber = this.Login.controls.phoneNo.value;
    // console.log(phoneNumber);

    this.login.phoneno = phoneNumber
    // console.log('log', this.login.phoneno);

    this.externalService.GetPhoneno(phoneNumber)

    this.externalService._getlogin.subscribe(response => {

      const phoneNumber = response
      // console.log(phoneNumber);

      this.phoneNo = phoneNumber
      // console.log('phoneNo', this.phoneNo);

      this.custid = this.phoneNo.custid
      // console.log('cusid', this.custid);

      // localStorage.setItem('custid', this.custid?.toString());

      // console.log('custid', custid);

      if (this.custid > 0) {

        this.otpshow = true;
        this.logphshow = false;
        this.loginshow = false;
        this.submitted = false

        const phoneNumber = this.Login.controls.phoneNo.value;
        // console.log(phoneNumber);

        this.mobile = phoneNumber

        this.externalService.GetOldCustomer(this.custid, phoneNumber, this.test);
        this.externalService._getoldCustomer.subscribe(response => {
          this.oldCus = response
          // console.log('oldCus', this.oldCus);
          var response = response as ExternalService[];
          if (response && response['status'] == 200) {
            //  this.toastrService.success('OTP', ' Otp Send Successfully')
            this.toastrService.success('OTP', response['service'])
          } else {
            this.toastrService.error('OTP', 'Otp Send UnSuccessfully !..')
          }

          this.customerId = this.oldCus.custid
          // console.log(this.customerId);

        })
        // console.log('Phone number matched. Showing OTP verification section.');
      } else {
        this.loginshow = true;
        this.logphshow = false
        this.otpshow = false;
        this.submitted = false
        // console.log('Phone number did not match. Showing login section.');
      }
    })

  }
  data: any;
  details: any;
  selectedQuestionId: number | null = null;
  selectedQuesByAns: any[] = []; // List of answers

  getchat() {
    this.productService.chatquestion(0).subscribe(x => {
      this.data = x;
      this.details = this.data.data || this.data;
      // console.log(this.details)
      localStorage.setItem('chatdetails', JSON.stringify(this.details));


      const chatdata = JSON.parse(localStorage.getItem('chatdetails') || '[]');
      // console.log(chatdata)
      this.details = chatdata

      let storedQues = JSON.parse(localStorage.getItem('chatQUes') || '[]');

      if (storedQues.length > 0) {
        this.chatQues = storedQues;
      }
    });

  }

  // selectQues(question: any) {
  //   this.selectedQuestionId = question.id;
  //   console.log("Selected Question:", question.name, "ID:", question.id);
  //       this.getAnswersForQuestion(this.selectedQuestionId);

  //   // You can also load related answers here if needed
  // }

  // getAnswersForQuestion(ID: number): void {
  //  this.productService.chatanswer(ID).subscribe(res => {
  //   console.log('API response:', res);
  //   this.selectedQuesByAns = res.getchat[0]["value"]  
  //   console.log(this.selectedQuesByAns)// fallback if getchat is missing
  // });
  // }

  selectQues(question: any) {
    this.selectedQuestionId = question.id;

    // Load existing IDs from localStorage
    const storedIds = JSON.parse(localStorage.getItem('clickedQuestions') || '[]');
    this.clickedQuestionIds = new Set(storedIds);

    if (this.clickedQuestionIds.has(question.id)) {
      // console.log("Question already clicked. Skipping API call.");
      return;
    }

    this.clickedQuestionIds.add(question.id);

    // Save updated list back to localStorage
    localStorage.setItem('clickedQuestions', JSON.stringify(Array.from(this.clickedQuestionIds)));

    this.getAnswersForQuestion(this.selectedQuestionId);
  }






  validateNumericInput(event: KeyboardEvent) {
    // console.log(event)
    const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const inputChar = event.key;

    if (!allowedKeys.includes(inputChar)) {
      event.preventDefault();
    }

  }



  // chatQues = [
  //   { id: 1, ques: "Top 5 rating Cakes", sendTime: '10:00 AM' },
  //   { id: 2, ques: "Top 2 best Cakes", sendTime: '10:01 AM' },
  //   { id: 3, ques: "Top 3 Premium Cakes", sendTime: '10:02 AM' },
  //   { id: 4, ques: "Top 1 selling Cakes", sendTime: '10:03 AM' }
  // ];

  // chatAns = [
  //   { id: 1, Ans: "blackforest", chatQId: 1, receiveTime: '10:10 AM' },
  //   { id: 2, Ans: "WhiteForest", chatQId: 1, receiveTime: '10:11 AM' },
  //   { id: 3, Ans: "ChocoTruffle", chatQId: 1, receiveTime: '10:12 AM' },
  //   { id: 4, Ans: "Dead By Chocolate", chatQId: 1, receiveTime: '10:13 AM' },
  //   { id: 5, Ans: "RedVelvet", chatQId: 1, receiveTime: '10:14 AM' },
  //   { id: 6, Ans: "blackforest", chatQId: 2, receiveTime: '10:20 AM' },
  //   { id: 7, Ans: "WhiteForest", chatQId: 2, receiveTime: '10:21 AM' },
  //   { id: 8, Ans: "ChocoTruffle", chatQId: 3, receiveTime: '10:30 AM' },
  //   { id: 9, Ans: "Dead By Chocolate", chatQId: 3, receiveTime: '10:31 AM' },
  //   { id: 10, Ans: "RedVelvet", chatQId: 3, receiveTime: '10:32 AM' },
  //   { id: 11, Ans: "ChocoTruffle", chatQId: 4, receiveTime: '10:40 AM' }
  // ];


  // selectedQuesByAns = [];

  // selectQues(id: number) {
  //   this.selectedQuesByAns = this.chatAns.filter(x => x.chatQId === id);
  // }

  // selectedQuestionId: number | null = null;


  // chatQA: any[] = [];

  // // Load chat from storage
  // loadChatFromStorage(): void {
  //   const savedQA = JSON.parse(localStorage.getItem('chatQA') || '[]');
  //   this.chatQA = savedQA;
  // }
  // // Loads the next 5 questions
  // loadNext5Questions() {
  //   this.next5data = this.Next5Ques(); // your logic to load next questions
  // }

  // getAnswersForQuestion(ID: number): void {
  //   console.log(this.next5data)
  //   this.productService.chatanswer(ID).subscribe(res => {
  //     if (res.getchat && res.getchat.length > 0) {
  //       const newAnswers = res.getchat.flatMap(item => item.Value || []);

  //       const selectedQuestion = this.details.find(q => q.id === ID) || this.next5data.find(q => q.id === ID);

  //       const storedQA = JSON.parse(localStorage.getItem('chatQA') || '[]');
  //       const updatedQA = storedQA.filter((item: any) => item.question.id !== ID);

  //       updatedQA.push({
  //         question: selectedQuestion,
  //         answers: newAnswers
  //       });

  //       localStorage.setItem('chatQA', JSON.stringify(updatedQA));
  //       this.chatQA = updatedQA;

  //     }
  //   });
  // }




  // next5data: any = [];

  // // Load Next 5 Questions (Pagination-like)
  // Next5Ques() {
  //   const lastItem = this.details[this.details.length - 1];
  //   const lastId = lastItem?.id || 0;

  //   this.productService.chatquestion(lastId).subscribe(x => {
  //     this.next5data = x["data"] || [];
  //     console.log(this.next5data);

  //     // Load stored QA or start fresh
  //     let storedQA = JSON.parse(localStorage.getItem('chatQA') || '[]');

  //     // Add "Others" marker if not already present
  //     if (!storedQA.some((item: any) => item.question.name === 'Others')) {
  //       storedQA.push({
  //         question: { id: 0, name: 'Others' },
  //         answers: []
  //       });
  //     }

  //     // Add new next5 questions only if not already present
  //     this.next5data.forEach(ele => {
  //       const exists = storedQA.some((item: any) => item.question.id === ele.id);
  //       if (!exists) {
  //         storedQA.push({
  //           question: { id: ele.id, name: ele.name },
  //           answers: []
  //         });
  //       }
  //     });

  //     // Save and update
  //     localStorage.setItem('chatQA', JSON.stringify(storedQA));
  //     this.chatQA = storedQA;
  //   });
  // }

  chatQA: any[] = [];
  chatQues: any[] = [];
  next5data: any[] = [];



  loadChatFromStorage(): void {
    const savedQA = JSON.parse(localStorage.getItem('chatQA') || '[]');
    this.chatQA = savedQA;
  }

  getAnswersForQuestion(ID: number): void {
    // console.log(ID)
    // console.log(this.details)
    // console.log(this.chatQues)
    const savedQA = JSON.parse(localStorage.getItem('chatQA') || '[]');
    this.chatQA = savedQA;
    // console.log(this.chatQA)

    this.productService.chatanswer(ID).subscribe(res => {
      if (res.getchat?.length > 0) {
        const newAnswers = res.getchat.flatMap(item => item.Value || []);
        const selectedQuestion =
          this.details.find(q => q.id === ID)
          || this.chatQues.find(q => q.id === ID)
          || this.chatQA.find(entry => entry.question?.id === ID)?.question
          || { id: ID, name: 'Unknown' };
        // console.log(selectedQuestion)
        const now = new Date();
        // console.log(selectedQuestion)
        // Append to chat flow
        this.chatQA.push({
          question: selectedQuestion,
          answers: newAnswers,
          time: now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
          timestamp: now.toISOString()
        });

        // Save
        localStorage.setItem('chatQA', JSON.stringify(this.chatQA));
        this.scrollToBottom();
      }
    });
  }

  Next5Ques(data: any): void {
    const lastItem = Array.isArray(data) ? data[data.length - 1] : data;
    const lastId = lastItem?.id || 0;

    this.productService.chatquestion(lastId).subscribe(res => {
      const new5 = res["data"] || [];
      this.chatQues = [...this.chatQues, ...new5];
      console.log(this.chatQues)
      const now = new Date();

      const othersEntry = {
        question: { id: 0, name: 'Others' },
        answers: [],
        time: now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        timestamp: now.toISOString(),
        next5: new5
      };

      this.chatQA.push(othersEntry);
      localStorage.setItem('chatQA', JSON.stringify(this.chatQA));
      this.scrollToBottom();
    });
  }

  scrollToBottom(): void {
    setTimeout(() => {
      const qaBlocks = document.querySelectorAll('.qa-block');
      const lastBlock = qaBlocks[qaBlocks.length - 1];
      lastBlock?.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  }


}
